import { render, staticRenderFns } from "./HeaderAuth.vue?vue&type=template&id=07b72b8c&scoped=true"
import script from "./HeaderAuth.vue?vue&type=script&lang=js"
export * from "./HeaderAuth.vue?vue&type=script&lang=js"
import style0 from "./HeaderAuth.vue?vue&type=style&index=0&id=07b72b8c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b72b8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b72b8c')) {
      api.createRecord('07b72b8c', component.options)
    } else {
      api.reload('07b72b8c', component.options)
    }
    module.hot.accept("./HeaderAuth.vue?vue&type=template&id=07b72b8c&scoped=true", function () {
      api.rerender('07b72b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/header/HeaderAuth.vue"
export default component.exports